export default {
    methods: {
        isInPeriod: function(start, end) {
            if (start == null && end == null) {
                return false;
            }
            let now = moment();
            // 現在日時がstart以上、end以下
            return now.isSameOrAfter(start) && now.isSameOrBefore(end);
        },
        nl2br: function(text) {
            if (text) {
                return text.replace(/\r?\n/g, '<br>');
            }
        }
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/front/common/Common.js